import castArray from 'lodash/castArray';
import { superpathjoin } from 'superpathjoin';
/**
 * Replace params in the polled url.
 * _WARNING_, this methods mutates `params` by removing all params
 * that have been replaced.
 */
export const replaceUrlParams = (url, params) => {
  const finalUrl = Object.keys(params).reduce((urlAcc, paramKey) => {
    const value = params[paramKey];
    const replaceRe = new RegExp(`:${paramKey}`, 'g');
    const shouldReplace = replaceRe.test(url);
    if (!shouldReplace) {
      return urlAcc;
    }

    // eslint-disable-next-line no-param-reassign
    delete params[paramKey];
    return urlAcc.replace(replaceRe, value);
  }, url);
  return finalUrl;
};

/**
 * Format a querystring from an url and parameters.
 */
export const toQueryString = (url, params) => {
  const queryParams = Object.keys(params).map(key => castArray(params[key]).map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')).join('&');
  return `${url}?${queryParams}`;
};

/**
 * Format the url for the SSE poller.
 * It takes an url, replace params inside, and concat remaining params
 * as a query string.
 */
export const formatUrl = (url, params) => {
  const copyParams = {
    ...params
  };
  let formattedUrl;
  formattedUrl = replaceUrlParams(url, copyParams);
  formattedUrl = toQueryString(formattedUrl, copyParams);
  return formattedUrl;
};

/**
 * Return the path of the middleware endpoint by taking into account
 * duplicate slashed, empty app endpoints (/), etc.
 */
export const getMiddlewareEndpointUrl = superpathjoin;